var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47768 20.625H0.330357V7.18887H4.47768V20.625ZM2.40179 5.35605C1.07589 5.35605 0 4.25098 0 2.9168C0 2.27582 0.253045 1.6611 0.703467 1.20786C1.15389 0.754626 1.76479 0.5 2.40179 0.5C3.03878 0.5 3.64968 0.754626 4.1001 1.20786C4.55053 1.6611 4.80357 2.27582 4.80357 2.9168C4.80357 4.25098 3.72768 5.35605 2.40179 5.35605ZM19.9955 20.625H15.8571V14.0844C15.8571 12.5256 15.8259 10.5266 13.7009 10.5266C11.5446 10.5266 11.2143 12.2201 11.2143 13.9721V20.625H7.07143V7.18887H11.0491V9.02168H11.1071C11.6607 7.96602 13.0134 6.85195 15.0313 6.85195C19.2277 6.85195 20 9.63262 20 13.2443V20.625H19.9955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.f415c04f8e57ec1e40a4fb27d7c11437.svg";
export { ForwardRef as ReactComponent };